import { apiCall, apiClient } from '@/shared/api';

/**
 * Refresh: el navegador envia la cookie HttpOnly automaticamente
 * (`credentials: 'include'` esta en el cliente).
 *
 * `me()` (lectura del perfil de la sesion) vive en `@/entities/usuario`
 * porque es una query del dominio Usuario; los features de auth la
 * consumen desde ahi.
 */
export async function refresh(): Promise<{ accessToken: string }> {
  return apiCall<{ accessToken: string }>(apiClient.POST('/api/v1/auth/refresh', { body: {} }));
}
